
import { ApiClient } from "../api/ApiClient";
import { BaseModel } from "../model/base/BaseModel";

const BASE_ULR = "/api/uom";

class UOMServiceClass {

  getListUOM() {
    return ApiClient.get<BaseModel[]>(BASE_ULR + "/list");
  }

  createNewUOM(name: string) {
    return ApiClient.post<BaseModel>(BASE_ULR + `/save?value=${name}`);
  }

  updateUOM(id: number, name: string) {
    return ApiClient.put<BaseModel>(BASE_ULR + `/update/${id}?value=${name}`);
  }

  deleteUOM(id: number) {
    return ApiClient.delete(BASE_ULR + `/delete/${id}`);
  }
}

const UOMService = new UOMServiceClass();
export default UOMService;